const Panel = ({ children }: React.PropsWithChildren) => {
  return <>{children}</>;
};

export default Panel;
